import React from 'react';

export default function FieldColor_FormValueEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-no-accent-default ui5-field-form-editable dropdown-form h-36", props.className)} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {_.get(props.field.components, 'ValuePrefix', false)}
                {props.field.placeholder}
            </div>
            {props.children}
        </React.Fragment>
    )
}